import IcUserStatusFreeIcon from './assets/free_icon.png';
import IcUserStatusFree from './assets/free.png';
import IcUserStatusStandardIcon from './assets/standard_icon.png';
import IcUserStatusStandard from './assets/standard.png';
import IcUserStatusGoldIcon from './assets/gold_icon.png';
import IcUserStatusGold from './assets/gold.png';
import IcUserStatusPlatinumIcon from './assets/platinum_icon.png';
import IcUserStatusPlatinum from './assets/platinum.png';
import IcUserStatusRoyalIcon from './assets/royal_icon.png';
import IcUserStatusRoyal from './assets/royal.png';
import IcUserStatusSilverIcon from './assets/silver_icon.png';
import IcUserStatusSilver from './assets/silver.png';
import IcUserStatusBronzeIcon from './assets/bronze_icon.png';
import IcUserStatusBronze from './assets/bronze.png';

import React, { memo } from 'react';
import { IAssetIconComponent } from '../../components/icon/Icon.t';
import { TUserStatusesStates } from './UserStatuses.t';

const iconsComponents = {
    free: IcUserStatusFree,
    standard: IcUserStatusStandard,
    bronze: IcUserStatusBronze,
    gold: IcUserStatusGold,
    platinum: IcUserStatusPlatinum,
    royal: IcUserStatusRoyal,
    silver: IcUserStatusSilver,
    free_icon: IcUserStatusFreeIcon,
    standard_icon: IcUserStatusStandardIcon,
    bronze_icon: IcUserStatusBronzeIcon,
    gold_icon: IcUserStatusGoldIcon,
    platinum_icon: IcUserStatusPlatinumIcon,
    royal_icon: IcUserStatusRoyalIcon,
    silver_icon: IcUserStatusSilverIcon,
} as const;

type IIconUserStatus = React.ComponentProps<IAssetIconComponent> & {
    name: string,
    size?: string | number,
    state?: TUserStatusesStates,
}

const IconUserStatus = memo<IIconUserStatus>((props) => {
    const { name, size = 24, style } = props;
    if (!name) {
        return null;
    }
    const currentName = size < 25 ? `${name}_icon` : name;
    if (!iconsComponents[currentName]) {
        return <></>;
    }
    return <img
        src={iconsComponents[currentName]}
        style={{
            width: '1em',
            height: '1em',
            fontSize: size || '1.5em',
            display: 'inline-block',
            lineHeight: 1.25,
            ...style,
        }}
        alt={''}/>;
});

export default IconUserStatus;
